import { SxProps, Theme } from '@mui/material';

export const styles = {
  container: {
    padding: 2,
    paddingBottom: 10,
  } as SxProps<Theme>,

  section: {
    marginBottom: 4,
  } as SxProps<Theme>,

  sectionTitle: {
    marginBottom: 2,
  } as SxProps<Theme>,

  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px',
  } as SxProps<Theme>,

  listPaper: (status: number) => ({
    padding: 2,
    cursor: 'pointer',
    minHeight: '80px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    transition: 'all 0.2s',
    backgroundColor: status === 1 ? '#ffffd7' : status === 10 ? '#d4f0ff' : 'background.paper',
    '&:hover': {
      elevation: 4,
      transform: 'translateY(-2px)',
      boxShadow: 4,
    },
    '&:active': {
      transform: 'translateY(0)',
    },
  } as SxProps<Theme>),

  listTitle: {
    fontFamily: "'Caveat', cursive",
  },

  listDate: {
    fontFamily: "'Caveat', cursive",
    fontSize: '1.2rem',
  },

  archivedItem: {
    padding: 1.5,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid',
    borderColor: 'divider',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: 'action.hover',
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  } as SxProps<Theme>,

  addButtonContainer: {
    position: 'fixed' as const,
    bottom: 0,
    left: 0,
    right: 0,
    padding: 2,
    backgroundColor: 'background.paper',
    borderTop: '1px solid',
    borderColor: 'divider',
    zIndex: 1000,
  } as SxProps<Theme>,

  addButton: {
    paddingY: 1.5,
  } as SxProps<Theme>,
};